import React from 'react';

import { IconProps, StyledPath, StyledSvg } from '../iconCommons';

export const IconCheckmarkCircle = ({ color = 'currentColor', size = 'medium', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 17" size={size} {...props}>
        <StyledPath
            color={color}
            d="M1.5 8.5a7.5 7.5 0 1 0 15 0 7.5 7.5 0 0 0-15 0Z"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <StyledPath
            stroke="#fff"
            d="m5 9.316 1.633 2.318a.7.7 0 0 0 1.138.034L13 5.052"
            color="none"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </StyledSvg>
);
